import React from 'react';
import styled from '@emotion/styled';
import { TourStoryType, TourStoryURLType } from '../../../../types/tourStory';
import { VideoDefault } from '../../../../assets';
import { InputVideo, ButtonActionPage } from '../../../atoms';

interface ColumnProps {
  record: TourStoryType;
  handleChangeInputVideo: Function;
  handleAddVideo: Function;
  loading?: boolean;
  onOpenModal: Function;
}

export default React.memo((props: ColumnProps) => {
  const { record, handleChangeInputVideo, handleAddVideo, loading, onOpenModal } = props;
  const isImageUrl = record.type === TourStoryURLType.IMAGE;
  const isSwitchVideo = !!record.isSwitchVideo;
  let imageLink = '';
  if (record.type === TourStoryURLType.IMAGE) {
    imageLink = `url('${record.url}')`;
  } else {
    imageLink = `url('${VideoDefault}')`;
  }

  const renderImageView = () => {
    return (
      <StyledTourStoryContainer onClick={() => window.open(record?.url, '_blank')}>
        <div className="image" style={{ backgroundImage: imageLink }} />
        <div className="box">{record?.url}</div>
      </StyledTourStoryContainer>
    );
  };

  const renderVideoView = () => {
    return (
      <StyledTourStoryContainer onClick={() => window.open(record?.url, '_blank')}>
        <div className="render-video">{record?.url}</div>
      </StyledTourStoryContainer>
    );
  };

  const renderCreateImage = () => {
    return (
      <BtnContainer>
        <ButtonActionPage
          onClick={() => onOpenModal(record?.index)}
          text="UPLOAD IMAGE"
          id="1"
          className="btn-submit-form-home"
          htmlType="click"
        />
      </BtnContainer>
    );
  };

  const renderCreateVideo = () => {
    return (
      <InputVideo
        loading={loading}
        record={record}
        handleChangeInputVideo={handleChangeInputVideo}
        handleAddVideo={handleAddVideo}
      />
    );
  };

  const renderView = () => {
    return isImageUrl ? renderImageView() : renderVideoView();
  };

  const renderCreate = () => {
    return isSwitchVideo ? renderCreateVideo() : renderCreateImage();
  };

  return record && record.type ? renderView() : renderCreate();
});

const StyledTourStoryContainer = styled.div`
  display: flex;
  align-items: center;
  .image {
    min-width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .box {
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .render-video {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px;
  }
`;

const BtnContainer = styled.div`
  & .btn-submit-form-home {
    position: absolute;
    left: 7px;
    bottom: 0;
    top: 5px;
    width: 150px;
    height: 40px;
    font-size: 12px;
    font-weight: 700;
  }
`;
